import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons'
import { Anchor, Box, Flex, Text, Title } from '@mantine/core'
import Link from 'next/link'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useStoreDetails } from '../../hooks/useStoreDetails'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import { Container } from './Container'
import styles from './styles.module.css'

export function Footer() {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })

  const path = useStorePathBuilder()
  const store = useStoreDetails()

  return (
    <Box className={styles.footer}>
      <Container>
        <Flex
          mt='xl'
          pb='lg'
          align='center'
          justify='space-between'
          wrap='wrap'
          gap='md'
        >
          <Box>
            <Title order={5}>{store?.name}</Title>
            <Text c='dimmed'>{store?.slogan?.replace(/<[^>]*>?/gm, '')}</Text>
          </Box>
          <Flex align='center' justify='flex-end' gap='md'>
            {store?.terms_and_conditions && (
              <Anchor component={Link} href={path('/terms')}>
                {t('footer.label_terms_and_conditions')}
              </Anchor>
            )}
            {store?.social_linkedin_url && (
              <Anchor
                href={store?.social_linkedin_url}
                target='_blank'
                c='dark.9'
              >
                <Icon size='lg' icon={faLinkedin} />
              </Anchor>
            )}
            {store?.social_instagram_url && (
              <Anchor
                href={store?.social_instagram_url}
                target='_blank'
                c='dark.9'
              >
                <Icon size='lg' icon={faInstagram} />
              </Anchor>
            )}
            {store?.social_facebook_url && (
              <Anchor
                href={store?.social_facebook_url}
                target='_blank'
                c='dark.9'
              >
                <Icon size='lg' icon={faFacebook} />
              </Anchor>
            )}
            {store?.social_twitter_url && (
              <Anchor
                href={store?.social_twitter_url}
                target='_blank'
                c='dark.9'
              >
                <Icon size='lg' icon={faXTwitter} />
              </Anchor>
            )}
          </Flex>
        </Flex>
      </Container>
    </Box>
  )
}
